// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unified-course-map {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #e5e3df;
}

/* Ensure map container doesn't interfere */
.unified-course-map > div {
  position: relative !important;
}

/* Debug overlay should not block interactions */
.unified-course-map .debug-overlay {
  position: absolute;
  top: 10px;
  left: 10px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 10px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 1000;
  pointer-events: none; /* Critical: allows clicks to pass through */
  max-width: 200px;
  min-width: 150px;
  font-family: monospace;
}

/* Only interactive elements should capture pointer events */
.unified-course-map .debug-overlay button {
  pointer-events: auto;
}

/* Fix Google Maps rendering issues */
.gm-style {
    font-family: inherit !important;
    position: relative !important;
}

.gm-style > div:first-child {
    background-color: #e5e3df !important;
}

.gm-style > div {
    background: transparent !important;
}

/* Info Window Styling */
.info-window-content {
    min-width: 200px;
    max-width: 300px;
    font-size: 14px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
    padding: 8px;
}

.info-window-content h4 {
    margin: 0 0 8px 0;
    color: var(--fleetly-primary-navy);
    font-size: 16px;
    font-weight: 600;
}

.info-window-content p {
    margin: 4px 0;
    font-size: 12px;
    line-height: 1.4;
}

/* Mark info specific styling */
.mark-info {
    max-width: 280px;
}

.mark-info h4 {
    color: #1976d2;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 4px;
    margin-bottom: 8px;
}

.mark-details p {
    margin: 6px 0;
    font-size: 13px;
}

/* Boat info specific styling */
.boat-info {
    max-width: 300px;
}

.boat-info h4 {
    color: var(--fleetly-primary-navy);
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 4px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.boat-info h4::before {
    content: "⛵";
    font-size: 16px;
}

.boat-details p {
    margin: 6px 0;
    font-size: 13px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.boat-details strong {
    color: #555;
    min-width: 90px;
}

/* Prevent marker click conflicts */
.gm-style .gm-style-iw {
    top: 0 !important;
    left: 0 !important;
}

.gm-style .gm-style-iw-d {
    overflow: visible !important;
}

/* Loading and error states */
.map-loading,
.map-error {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: #e5e3df;
}

.loading-content,
.error-content {
  text-align: center;
  max-width: 300px;
}

.loading-content h3,
.error-content h3 {
  margin: 12px 0 6px 0;
  color: #333;
}

.loading-content p,
.error-content p {
  margin: 0;
  color: #666;
  font-size: 14px;
}

.map-error-recovery {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: #f5f5f5;
    padding: 20px;
}

.map-error-recovery button {
    margin-top: 10px;
    padding: 8px 16px;
    background: var(--fleetly-primary-navy);
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.map-error-recovery button:hover {
    background: #1976d2;
}

/* Add these styles to make boat trails more prominent */
.boat-trail {
  stroke-width: 4px !important;
  stroke-opacity: 0.8 !important;
}

/* Make boat markers more visible */
.boat-marker {
  z-index: 200 !important;
}

/* Boat label styling */
.boat-label {
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 2px 4px;
  border-radius: 3px;
  font-size: 10px;
  font-weight: bold;
  font-family: Arial, sans-serif;
  white-space: nowrap;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  transform: translate(-50%, -100%);
  margin-top: -2px;
  z-index: 1000;
  min-width: 16px;
  text-align: center;
  line-height: 1.2;
  pointer-events: none; /* Prevent label from blocking boat clicks */
}

.boat-label.selected {
  background: #1976d2;
  border-color: rgba(255, 255, 255, 0.5);
}

/* Ensure trails render below markers but above map background */
.trail-line {
  z-index: 50 !important;
}

/* Prevent map graying out */
.gm-style {
    font-family: inherit !important;
}

.gm-style > div:first-child {
    background-color: transparent !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/UnifiedCourseMap.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,6BAA6B;AAC/B;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,oBAAoB,EAAE,4CAA4C;EAClE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,4DAA4D;AAC5D;EACE,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;IACI,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;AACtC;;AAEA,wBAAwB;AACxB;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,gFAAgF;IAChF,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kCAAkC;IAClC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA,+BAA+B;AAC/B;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA,+BAA+B;AAC/B;IACI,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,gCAAgC;IAChC,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA,mCAAmC;AACnC;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,6BAA6B;AAC7B;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,WAAW;AACb;;AAEA;;EAEE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,uCAAuC;IACvC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,wDAAwD;AACxD;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA,mCAAmC;AACnC;EACE,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,0CAA0C;EAC1C,wCAAwC;EACxC,iCAAiC;EACjC,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB,EAAE,4CAA4C;AACpE;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA,gEAAgE;AAChE;EACE,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;IACI,+BAA+B;AACnC;;AAEA;IACI,wCAAwC;AAC5C","sourcesContent":[".unified-course-map {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background: #e5e3df;\n}\n\n/* Ensure map container doesn't interfere */\n.unified-course-map > div {\n  position: relative !important;\n}\n\n/* Debug overlay should not block interactions */\n.unified-course-map .debug-overlay {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  background: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  z-index: 1000;\n  pointer-events: none; /* Critical: allows clicks to pass through */\n  max-width: 200px;\n  min-width: 150px;\n  font-family: monospace;\n}\n\n/* Only interactive elements should capture pointer events */\n.unified-course-map .debug-overlay button {\n  pointer-events: auto;\n}\n\n/* Fix Google Maps rendering issues */\n.gm-style {\n    font-family: inherit !important;\n    position: relative !important;\n}\n\n.gm-style > div:first-child {\n    background-color: #e5e3df !important;\n}\n\n.gm-style > div {\n    background: transparent !important;\n}\n\n/* Info Window Styling */\n.info-window-content {\n    min-width: 200px;\n    max-width: 300px;\n    font-size: 14px;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n    padding: 8px;\n}\n\n.info-window-content h4 {\n    margin: 0 0 8px 0;\n    color: var(--fleetly-primary-navy);\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.info-window-content p {\n    margin: 4px 0;\n    font-size: 12px;\n    line-height: 1.4;\n}\n\n/* Mark info specific styling */\n.mark-info {\n    max-width: 280px;\n}\n\n.mark-info h4 {\n    color: #1976d2;\n    border-bottom: 1px solid #e0e0e0;\n    padding-bottom: 4px;\n    margin-bottom: 8px;\n}\n\n.mark-details p {\n    margin: 6px 0;\n    font-size: 13px;\n}\n\n/* Boat info specific styling */\n.boat-info {\n    max-width: 300px;\n}\n\n.boat-info h4 {\n    color: var(--fleetly-primary-navy);\n    border-bottom: 1px solid #e0e0e0;\n    padding-bottom: 4px;\n    margin-bottom: 8px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.boat-info h4::before {\n    content: \"⛵\";\n    font-size: 16px;\n}\n\n.boat-details p {\n    margin: 6px 0;\n    font-size: 13px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.boat-details strong {\n    color: #555;\n    min-width: 90px;\n}\n\n/* Prevent marker click conflicts */\n.gm-style .gm-style-iw {\n    top: 0 !important;\n    left: 0 !important;\n}\n\n.gm-style .gm-style-iw-d {\n    overflow: visible !important;\n}\n\n/* Loading and error states */\n.map-loading,\n.map-error {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    background: #e5e3df;\n}\n\n.loading-content,\n.error-content {\n  text-align: center;\n  max-width: 300px;\n}\n\n.loading-content h3,\n.error-content h3 {\n  margin: 12px 0 6px 0;\n  color: #333;\n}\n\n.loading-content p,\n.error-content p {\n  margin: 0;\n  color: #666;\n  font-size: 14px;\n}\n\n.map-error-recovery {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    background: #f5f5f5;\n    padding: 20px;\n}\n\n.map-error-recovery button {\n    margin-top: 10px;\n    padding: 8px 16px;\n    background: var(--fleetly-primary-navy);\n    color: white;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.map-error-recovery button:hover {\n    background: #1976d2;\n}\n\n/* Add these styles to make boat trails more prominent */\n.boat-trail {\n  stroke-width: 4px !important;\n  stroke-opacity: 0.8 !important;\n}\n\n/* Make boat markers more visible */\n.boat-marker {\n  z-index: 200 !important;\n}\n\n/* Boat label styling */\n.boat-label {\n  position: absolute;\n  background: rgba(0, 0, 0, 0.7);\n  color: white;\n  padding: 2px 4px;\n  border-radius: 3px;\n  font-size: 10px;\n  font-weight: bold;\n  font-family: Arial, sans-serif;\n  white-space: nowrap;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n  transform: translate(-50%, -100%);\n  margin-top: -2px;\n  z-index: 1000;\n  min-width: 16px;\n  text-align: center;\n  line-height: 1.2;\n  pointer-events: none; /* Prevent label from blocking boat clicks */\n}\n\n.boat-label.selected {\n  background: #1976d2;\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n/* Ensure trails render below markers but above map background */\n.trail-line {\n  z-index: 50 !important;\n}\n\n/* Prevent map graying out */\n.gm-style {\n    font-family: inherit !important;\n}\n\n.gm-style > div:first-child {\n    background-color: transparent !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
